import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const UnreadNotificationIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2.75 4.08594L8 7.46094L13.625 4.08594M3.5 12.2055C2.67157 12.2055 2 11.5339 2 10.7055V4.83594C2 4.00751 2.67157 3.33594 3.5 3.33594H12.5C13.3284 3.33594 14 4.00751 14 4.83594V10.7055C14 11.5339 13.3284 12.2055 12.5 12.2055H3.5Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13.5" cy="3.5" r="3" fill="currentColor" />
    </BaseIcon>
  );
};

UnreadNotificationIcon.displayName = 'UnreadNotificationIcon';
